import {
  Button,
  ButtonColor,
  ButtonSize,
  IconGraduateHat,
  IconPromotion,
  IconTest,
} from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import { type FC, type SVGProps } from 'react';

import { GoalName } from '../../../__generated-gql-types__/globalTypes';
import { formatGoalDescription } from '../../../utils/formatters';
import { getReviewsPageUrl } from '../../../utils/routing';

interface FilterGoal {
  Icon: FC<SVGProps<SVGSVGElement>>;
  iconColor: string;
  activeColor: ButtonColor;
  goal: GoalName;
}
const goals: FilterGoal[] = [
  {
    Icon: IconPromotion,
    iconColor: 'text-leland-blue',
    activeColor: ButtonColor.BLUE,
    goal: GoalName.CAREER,
  },
  {
    Icon: IconGraduateHat,
    iconColor: 'text-leland-primary',
    activeColor: ButtonColor.PRIMARY,
    goal: GoalName.SCHOOL,
  },
  {
    Icon: IconTest,
    iconColor: 'text-leland-orange',
    activeColor: ButtonColor.ORANGE,
    goal: GoalName.TEST,
  },
];

interface ReviewFiltersProps {
  goalSearch: Possible<GoalName>;
  ratingSearch: Possible<number>;
}
export const ReviewFilters: FC<ReviewFiltersProps> = ({
  goalSearch,
  ratingSearch,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="hidden sm:inline">Filter by goal</span>
      {goals.map((filterGoal) => (
        <RatingFilterButton
          filterGoal={filterGoal}
          href={getReviewsPageUrl(
            filterGoal.goal === goalSearch ? null : filterGoal.goal,
            ratingSearch,
          )}
          isActive={goalSearch === filterGoal.goal}
          key={filterGoal.goal}
        />
      ))}
    </div>
  );
};

interface RatingFilterButtonProps {
  filterGoal: FilterGoal;
  isActive: boolean;
  href: string;
}
const RatingFilterButton: FC<RatingFilterButtonProps> = ({
  filterGoal: { Icon, iconColor, goal, activeColor },
  isActive,
  href,
}) => {
  return (
    <Link href={href} id="review_filters--filter_by_goal">
      <Button
        buttonColor={isActive ? activeColor : ButtonColor.WHITE}
        label={formatGoalDescription(goal)}
        rounded
        size={ButtonSize.MEDIUM}
        {...(isActive
          ? { LeftIcon: Icon }
          : {
              CustomLeftIcon: ({ iconClassName }) => (
                <Icon className={`${iconClassName} ${iconColor}`} />
              ),
            })}
      />
    </Link>
  );
};
